import React, { Component } from 'react'
import Link from 'gatsby-link'
import Hamburger from 'components/icons/Hamburger'
import horizontalLogo from 'static/logos/horizontal-logo.png'

const NavMenuButtonWrapper = ({ children, noBorder }) => (
  <div className={`border-grey ${noBorder ? 'border-b-0' : 'border-b'}`}>
    {children}
  </div>
)

const MobileMenuContainer = ({ children }) => (
  <div
    className="absolute bg-white right-0 mt-4 z-20 select-none"
    style={{
      width: 280,
      borderRadius: '12px',
      boxShadow:
        '0 13px 27px -5px rgba(50, 50, 93, 0.25), 0 8px 16px -8px rgba(0, 0, 0, 0.3)',
      border: '1px solid #e3e8ee'
    }}
  >
    <div className="p-2">{children}</div>
  </div>
)

const NavLink = ({ to, children, className = '' }) => (
  <Link
    className={`text-navyLight font-medium text-base px-4 py-2 rounded-md transition-all duration-150 hover:text-primary hover:bg-offWhite ${className}`}
    to={to}
  >
    {children}
  </Link>
)

const MobileNavLink = ({ to, children }) => (
  <Link
    className="block text-navyLight font-medium text-base px-4 py-3 rounded-lg transition-all duration-150 hover:text-primary hover:bg-offWhite"
    to={to}
  >
    {children}
  </Link>
)

class Nav extends Component {
  state = {
    open: false,
    scrolled: false
  }

  toggleMobileMenu = () => {
    const { open } = this.state

    this.setState({
      open: !open
    })
  }

  close = () => {
    this.setState({ open: false })
  }

  handleScroll = () => {
    const scrolled = window.scrollY > 10
    if (scrolled !== this.state.scrolled) {
      this.setState({ scrolled })
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentDidUpdate() {
    if (this.state.open) {
      document.addEventListener('click', this.close)
    } else {
      document.removeEventListener('click', this.close)
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.close)
    window.removeEventListener('scroll', this.handleScroll)
  }

  render() {
    const { open, scrolled } = this.state

    return (
      <nav
        className={`flex items-center py-3 px-4 transition-all duration-200 ${
          scrolled ? 'bg-white' : 'bg-transparent'
        }`}
        style={{
          minHeight: 72,
          boxShadow: scrolled ? '0 1px 0 0 #e3e8ee' : 'none',
          position: 'sticky',
          top: 0,
          zIndex: 50
        }}
      >
        <div className="container mx-auto flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src={horizontalLogo}
              alt="Oregon City Smiles"
              style={{ height: '44px' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/about_us">About Us</NavLink>
            <NavLink to="/emergency_care">Emergency Care</NavLink>
            <NavLink to="/treatments">Treatments</NavLink>
            <Link
              to="/appointments"
              className="px-4 py-2 bg-primary text-white font-medium text-base rounded-lg transition-all duration-150 hover:bg-primaryDark"
              style={{
                boxShadow:
                  '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)'
              }}
            >
              Book Appointment
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <div className="block md:hidden relative">
            <div
              onClick={this.toggleMobileMenu}
              className="p-2 rounded-lg cursor-pointer hover:bg-offWhite transition-colors duration-150"
            >
              <Hamburger />
            </div>
            {open && (
              <MobileMenuContainer>
                <NavMenuButtonWrapper>
                  <MobileNavLink to="/">Home</MobileNavLink>
                </NavMenuButtonWrapper>
                <NavMenuButtonWrapper>
                  <MobileNavLink to="/about_us">About Us</MobileNavLink>
                </NavMenuButtonWrapper>
                <NavMenuButtonWrapper>
                  <MobileNavLink to="/emergency_care">
                    Emergency Care
                  </MobileNavLink>
                </NavMenuButtonWrapper>
                <NavMenuButtonWrapper>
                  <MobileNavLink to="/treatments">Treatments</MobileNavLink>
                </NavMenuButtonWrapper>
                <NavMenuButtonWrapper noBorder>
                  <Link
                    to="/appointments"
                    className="block text-center mx-2 my-2 px-4 py-3 bg-primary text-white font-medium text-base rounded-lg transition-all duration-150 hover:bg-primaryDark"
                  >
                    Book Appointment
                  </Link>
                </NavMenuButtonWrapper>
              </MobileMenuContainer>
            )}
          </div>
        </div>
      </nav>
    )
  }
}

export default Nav
